const DEFAULT_DOWNLOAD_ENDPOINT = "/api/client/rent-contract/dowload/{rentProcessId}";

export function resolveDownloadEndpoint(
  rentProcessId: number,
  template = DEFAULT_DOWNLOAD_ENDPOINT
): string {
  const path = template.replace("{rentProcessId}", String(rentProcessId));

  return path.startsWith("/") ? path : `/${path}`;
}
